// extracted by mini-css-extract-plugin
export default {"CheckBox":"CheckBox_CheckBox__2iZ5e","CheckBoxInput":"CheckBox_CheckBoxInput__hzMMC","CheckBoxLabel":"CheckBox_CheckBoxLabel__zw+jM"};